import { Divider, Grid, Typography } from "@mui/material";
import React from "react";
import {useForm } from "react-hook-form";
import config from "../../Config/clientConfig.json";
import WSSelectField from "../../Components/Select/WSSelect";
import WSDateField from "../../Components/DateField/WSDateField";
import WSSCheckBoxField from "../../Components/CheckBox/WSCheckBox";

export const SessionWiseReport:React.FC<any>=React.memo((props)=>{
  const { handleSubmit, control, register } = useForm();
   
      const onSubmit = async (data: any) => {
        console.log("onsubmit===>", data); // You can perform any action with the submitted data here
      };
    return(
              <form onSubmit={handleSubmit(onSubmit)}  style={{ width: '100%' }}>

                <Typography sx={{fontWeight: 500,fontSize: "0.875rem",color:"#1976d2"}}>FILTER CRITERIA</Typography>
                <Divider sx={{mt:1}}/>
                <Grid container spacing={2} sx={{mt:3}}>

      <Grid item xs={12} sm={2}>
        <Typography>From Date</Typography>
      </Grid>
      <Grid item xs={12} sm={4}>
        <WSDateField
          id="fromdate"
          name="fromdate"
          label=""
          dateFormat="D/MM/YYYY"
          control={control}
          defaultValue={null}
          rules={{ required: false }}
        />
      </Grid>
      <Grid item xs={12} sm={2}>
        <Typography>To Date</Typography>
      </Grid>
      <Grid item xs={12} sm={4}>
        <WSDateField
          id="todate"
          name="todate"
          label=""
          dateFormat="D/MM/YYYY"
          control={control}
          defaultValue={null}
          rules={{ required: false }}
        />
      </Grid>
      <Grid item xs={12} sm={2}>
        <Typography>User</Typography>
      </Grid>
      <Grid item xs={12} sm={4}>
        <WSSelectField
          rules={{ required: true }}
          {...register("user")}
          id="user"
          control={control}
          defaultValue={"0"}
          label=""
          name="user"
          options={config.userConfig.staticOptionData}
        />
      </Grid>
      <Grid item xs={12} sm={2}>
        <Typography>Session</Typography>
      </Grid>
      <Grid item xs={12} sm={4}>
        <WSSelectField
          rules={{ required: true }}
          {...register("session")}
          id="session"
          control={control}
          defaultValue={"0"}
          label=""
          name="session"
          options={config.sessionConfig.staticOptionData}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <WSSCheckBoxField
          id="showreceiptsummary"
          name="showreceiptsummary"
          label="Show Receipt Summary"
          control={control}
          rules={{ required: false }}
          defaultValue={false}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <WSSCheckBoxField
          id="showprinted"
          name="showprinted"
          label="Show Printed By Information"
          control={control}
          rules={{ required: false }}
          defaultValue={false}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <WSSCheckBoxField
          id="showdiscountsummary"
          name="showdiscountsummary"
          label="Show Discount Summary"
          control={control}
          rules={{ required: false }}
          defaultValue={false}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <WSSCheckBoxField
          id="showcategorysummary"
          name="showcategorysummary"
          label="Show Category Summary"
          control={control}
          rules={{ required: false }}
          defaultValue={false}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <WSSCheckBoxField
          id="amountbeforediscount"
          name="amountbeforediscount"
          label="Amount Before Discount"
          control={control}
          rules={{ required: false }}
          defaultValue={false}
        />
      </Grid>
      </Grid>
      <Grid
        sx={{
          mt: 4,
          p: 2,
          border: "1px solid black",
          height:"15rem"
        }}
      >
      
      </Grid>
            </form>
    )
})